import React from "react";
import DashboardLayout from "./DashboardLayout";
import { useSelector } from "react-redux";
import Notification from "../../../components/Notification/Notification";

const CorporateNotifications = () => {
  const user = useSelector((state) => state.AuthSlice.user);

  return (
    <>
      <DashboardLayout>
        <Notification userId={user?.id} />
      </DashboardLayout>
    </>
  );
};

export default CorporateNotifications;
